// eslint-disable-next-line import/no-unresolved, import/extensions
import Success from './SuccessFlowV2';

export default Success;
